<mat-card class="p-2 m-2">
    <mat-card-header>
        <div class="flex justify-between w-full">
            <mat-card-title>{{ titulo }}</mat-card-title>
            <button (click)="verDetalle()" mat-icon-button aria-label="Ver detalle">
                <mat-icon>edit</mat-icon>
            </button>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="flex flex-col">
            <ng-content></ng-content>
        </div>
    </mat-card-content>
</mat-card>
